
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { NavigationService } from '../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sm-businesses',
  templateUrl: './businesses.component.html',
  styleUrls: ['./businesses.component.scss']
})
export class BusinessesComponent implements OnInit, OnDestroy {

  messageList: any[] = [];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "date of add",
      columnProperty: "senderPhone"
    },
    {
      columnName: "business name",
      columnProperty: "entityName"
    },
    {
      columnName: "address",
      columnProperty: "addressInfo"
    },
    {
      columnName: "status",
      columnProperty: "isActive"
    },
  ];
  // private _apiSubscription: Subscription;

  constructor(private _apiService: ApiService, private _navService: NavigationService, private router: Router, private route: ActivatedRoute) { 
    this._navService.hideSidebarAndNav = false;
  //   this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
  //     if(resData.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT){
  //       console.log(resData);
  //       this.messageList = resData.result ? resData.result : [];
  //       // console.log( this.messageList);
  //       this.messageList.forEach((item )=> {
  //         item.addressInfo = JSON.parse(item.addressInfo).address_line
  //       })
  //           console.log( this.messageList);
        
  //     }
  //   });
  // }
  }


  ngOnInit(): void {
    // this._apiService.getBusinessList();
  }

  ngOnDestroy(): void {
    // this._apiSubscription.unsubscribe();
  }

  // test(row:any){
  //   console.log(row);
    
  // }
test(){
  console.log("clicked");
  this.router.navigate(['/businesses','documents'])
}

}
